import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector, combinedSettingsSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import Component, { type CountersComponentProps } from "./component";
import { makeCountToOptionsSelector } from "./selectors";

const makeMapStateToProps = () => {
  const countToOptionsSelector = makeCountToOptionsSelector();

  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, [
    "appendText",
    "horizontalAlign",
    "prependText"
  ]);

  return (state: AppState, props: RootContainerProps): CountersComponentProps => {
    const settings = settingsSelector(state, props);

    return {
      countToOptions: countToOptionsSelector(state, props),
      ...settings,
      ...props
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
